import { IIngredient } from 'interfaces/IIngredient'
import BaseAutocomplete from './baseAutocomplete'

const headers = [
  {
    id: 'ingredientId',
    numeric: false,
    disablePadding: true,
    label: 'Kode Bahan Baku',
    width: 'medium',
  },
  {
    id: 'ingredientName',
    numeric: false,
    disablePadding: false,
    label: 'Nama Bahan Baku',
    width: 'medium',
  },
  {
    id: 'stock',
    numeric: false,
    disablePadding: false,
    label: 'Stok',
    width: 'small',
  },
]

export default function LoadIngredientAutocomplete(props: {
  name?: string
  onChange?: (ingredient: IIngredient) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (ingredients: IIngredient[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
}) {
  const { name, loadAll } = props

  let url = '/ingredients/getIngredient'

  const responseMapper = (ingredient: IIngredient) => {
    return `${ingredient.ingredientId} - ${ingredient.ingredientName}`
  }

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      headers={headers}
      label="Bahan Baku"
      loadAll={loadAll}
      name={name}
      responseMapper={responseMapper}
    />
  )
}
